import Vue from "vue";
import i18n from "@/i18n";
import dayjs from "dayjs";
// Vue.filter('carNameDisplay', (name, brand) => {
//   let value = ''
//   if (brand) {
//     value = value + '(' + brand + ') '
//   }
//   if (name) {
//     value = value + name
//   }
//   return value
// })

Vue.filter("comma", (value) => {
  if (value) {
    const parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  } else return 0;
});

Vue.filter("toFixed", (value) => {
  if (value) {
    return Number(value).toFixed(2);
  } else return 0;
});

Vue.filter("gender", (value) => {
  if (value === "M") return i18n.t("text.common.male");
  else return i18n.t("text.common.female");
});

Vue.filter("status", (status) => {
  if (status == 1) {
    return i18n.t("text.common.available");
  } else if (status == 2) {
    return i18n.t("text.common.unavailable");
  } else if (status == 3) {
    return i18n.t("text.common.in_use");
  }
});

Vue.filter("status2", (status) => {
  if (status == 1) {
    return i18n.t("text.common.available");
  } else if (status == 2) {
    return i18n.t("text.common.unavailable");
  } else {
    return i18n.t("text.common.in_use");
  }
});

Vue.filter("status3", (status) => {
  let s = "";
  switch (status) {
    case "1":
      s = i18n.t("text.common.ready");
      break;
    case "2":
      s = i18n.t("text.common.playing");
      break;
    case "3":
      s = i18n.t("text.common.move");
      break;
    case "4":
      s = i18n.t("text.common.terminated");
      break;
    case "5":
      s = i18n.t("text.common.terminated");
      break;
    case "6":
      s = i18n.t("text.common.completed");
      break;
  }
  return s;
});
Vue.filter("status4", (status) => {
  if (status === "0") {
    return i18n.t("text.admin.suspended");
  } else if (status === "1") {
    return i18n.t("text.admin.active");
  } else {
    return "-";
  }
});
Vue.filter("status5", (status) => {
  if (status === "1") {
    return i18n.t("filter.support.post");
  } else if (status === "0") {
    return i18n.t("filter.support.pending");
  } else {
    return "-";
  }
});

Vue.filter("status6", (status) => {
  if (status === "0") {
    return i18n.t("filter.support.ok");
  } else if (status === "1") {
    return i18n.t("filter.common.delete");
  } else {
    return "-";
  }
});

Vue.filter("memtype", (type) => {
  if (type === "0") {
    return i18n.t("text.common.guest");
  } else if (type === "1") {
    return i18n.t("text.common.member");
  } else {
    return "-";
  }
});

Vue.filter("score", (v) => {
  if (v === null) return "";
  if (v === 0) return "";
  return v;
});

Vue.filter("score2", (v) => {
  if (v == null) return "";
  if (v == 0) return "";
  return "(" + v + ")";
});

Vue.filter("levelType", (level) => {
  if (level === "1") {
    return i18n.t("text.common.pro");
  } else if (level === "2") {
    return i18n.t("text.common.semi_pro");
  } else if (level === "3") {
    return i18n.t("text.common.advanced");
  } else if (level === "4") {
    return i18n.t("text.common.normal");
  } else if (level === "5") {
    return i18n.t("text.common.beginner");
  } else {
    return "-";
  }
});
Vue.filter("windType", (wind) => {
  if (wind == 1) {
    return i18n.t("text.common.calm");
  } else if (wind == 2) {
    return i18n.t("text.common.light");
  } else if (wind == 3) {
    return i18n.t("text.common.moderate");
  } else if (wind == 4) {
    return i18n.t("text.common.strong");
  } else if (wind == 5) {
    return i18n.t("text.common.random");
  } else {
    return "-";
  }
});

Vue.filter("teeboxType", (teebox) => {
  if (teebox === "1") {
    // return i18n.t("text.common.pro") + "(" + i18n.t("text.common.blue") + ")";
    return i18n.t("text.common.blue");
  } else if (teebox === "2") {
    return (
      // i18n.t("text.common.regular") + "(" + i18n.t("text.common.white") + ")"
      i18n.t("text.common.white")
    );
  } else if (teebox === "3") {
    return i18n.t("text.common.red");
    // return i18n.t("text.common.lady") + "(" + i18n.t("text.common.red") + ")";
  } else if (teebox === "4") {
    return (
      // i18n.t("text.common.senior") + "(" + i18n.t("text.common.yellow") + ")"
      i18n.t("text.common.yellow")
    );
  } else {
    return "-";
  }
});

Vue.filter("partType", (part) => {
  if (part == 1) {
    return i18n.t("text.common.management_part");
  } else if (part == 2) {
    return i18n.t("text.common.research_part");
  } else if (part == 3) {
    return i18n.t("text.common.customer_part");
  } else if (part == 4) {
    return i18n.t("text.common.manufacturing_part");
  } else if (part == 5) {
    return i18n.t("text.common.sales_part");
  } else {
    return "-";
  }
});

Vue.filter("positionType", (position) => {
  if (position == 1) {
    return i18n.t("text.common.staff");
  } else if (position == 2) {
    return i18n.t("text.common.associate_manager");
  } else if (position == 3) {
    return i18n.t("text.common.manager");
  } else if (position == 4) {
    return i18n.t("text.common.team_leader");
  } else if (position == 5) {
    return i18n.t("text.common.deputy_manager");
  } else if (position == 6) {
    return i18n.t("text.common.general_manager");
  } else if (position == 7) {
    return i18n.t("text.common.director");
  } else {
    return "-";
  }
});

Vue.filter("category", (category, type) => {
  console.log(type);
  if (category == 1) {
    return i18n.t("filter.support.manual");
  } else if (category == 2) {
    if (type === "list") return i18n.t("filter.support.promotion");
    else return i18n.t("filter.support.promotional_material");
  } else if (category == 3) {
    if (type === "list") return i18n.t("filter.support.printed");
    else return i18n.t("filter.support.printed_material");
  } else if (category == 4) {
    return i18n.t("filter.support.other");
  } else {
    return "None";
  }
});

Vue.filter("get_img", (value) => {
  if (value) {
    return process.env.VUE_APP_S3_BUCKET_URL + "/" + value;
  } else {
    return "/img/no-img.png";
  }
});

Vue.filter("dateformat", (value, type) => {
  if (value) {
    if (type) return dayjs(value).format(type);
    else return dayjs(value).format("YYYY.MM.DD HH:mm");
  } else {
    return "-";
  }
});

Vue.filter("shot_index", (value) => {
  if (value) {
    return parseInt(value) + 1;
  } else return "-";
});

Vue.filter("transToValue", (value, text) => {
  if (value == "0") {
    return text;
  } else return value;
});

Vue.filter("tour_class", (value) => {
  switch (value) {
    case "1":
      return i18n.t("text.admin.regular");

    case "2":
      return i18n.t("text.admin.major");
  }
});

Vue.filter("tour_rank_type", (value) => {
  switch (value) {
    case "0":
      return (
        i18n.t("title.tournament.low_gross") +
        " / " +
        i18n.t("title.tournament.low_net")
      );
    case "1":
      return i18n.t("title.tournament.low_gross");

    case "2":
      return i18n.t("title.tournament.low_net");
  }
});

Vue.filter("suffix", (value, text) => {
  if (value == "0" || !value) {
    return "-";
  } else return value + text;
});

Vue.filter("get_club_type", (value) => {
  switch (value) {
    case "1":
      return i18n.t("text.common.driver");

    case "2":
      return i18n.t("text.common.wood");

    case "3":
      return i18n.t("text.common.utility");

    case "4":
      return i18n.t("text.common.iron");

    case "5":
      return i18n.t("text.common.wedge");

    case "6":
      return i18n.t("text.common.putter");
  }
});

Vue.filter("price_unit", (value, text = "") => {
  if (process.env.VUE_APP_PRICE_UNIT === "AUD") {
    return "$ " + value + " AUD";
  }
  return "$ " + value;
});

Vue.filter("stripe_unit_amount", (value, unit = "usd") => {
  const amount = parseFloat(value);
  const currency = unit.toLowerCase();

  let convertedAmount;

  switch (currency) {
    case "usd":
    case "aud":
    case "eur":
    case "cad":
      // 센트 단위 → 소수 2자리까지 표시
      convertedAmount = (amount / 100).toFixed(2);
      break;

    case "jpy":
    case "krw":
    case "vnd":
      // 최소 단위가 원화, 엔화처럼 정수로 되어있음
      convertedAmount = amount.toFixed(0);
      break;

    default:
      // 기본은 소수 2자리
      convertedAmount = (amount / 100).toFixed(2);
      break;
  }
  return `${convertedAmount} ${currency.toUpperCase()}`;
});

Vue.filter("awardtype", (value) => {
  switch (value) {
    case "1":
      return i18n.t("text.common.status_public");
    case "2":
      return i18n.t("text.common.status_invitational");
    default:
      return i18n.t("text.common.status_public");
  }
});

Vue.filter("greenspeed", (status) => {
  let s = "";
  switch (status) {
    case "1":
      s = i18n.t("title.common.veryfast");
      break;
    case "2":
      s = i18n.t("title.common.fast");
      break;
    case "3":
      s = i18n.t("title.common.normal");
      break;
    case "4":
      s = i18n.t("title.common.slow");
      break;
    case "5":
      s = i18n.t("title.common.veryslow");
      break;
  }
  return s;
});
Vue.filter("greengravity", (status) => {
  let s = "";
  switch (status) {
    case "1":
      s = i18n.t("title.common.veryhigh");
      break;
    case "2":
      s = i18n.t("title.common.high");
      break;
    case "3":
      s = i18n.t("title.common.middle");
      break;
    case "4":
      s = i18n.t("title.common.low");
      break;
    case "5":
      s = i18n.t("title.common.verylow");
      break;
  }
  return s;
});
Vue.filter("concede", (status) => {
  let s = "";
  switch (status) {
    case "1":
      s = i18n.t("title.common.concede_none");
      break;
    case "2":
      s = i18n.t("title.common.concede_1m");
      break;
    case "3":
      s = i18n.t("title.common.concede_1_5m");
      break;
    case "4":
      s = i18n.t("title.common.concede_2m");
      break;
    case "5":
      s = i18n.t("title.common.concede_3m");
      break;
    case "6":
      s = i18n.t("title.common.concede_4m");
      break;
  }
  return s;
});
